import React from 'react';

interface FilledInputProps {
  testId?: string;
  className?: string;
  text?: string;
  value?: string;
  disabled?: boolean;
  readonly?: boolean;
  name?: string;
  required?: boolean;
  handleChange?: (text: string) => void;
}

export const FilledInput: React.FC<FilledInputProps> = ({
  testId,
  className,
  text,
  disabled,
  readonly = false,
  name,
  value,
  required = false,
  handleChange,
}) => {
  return (
    <input
      required={required}
      readOnly={readonly}
      name={name}
      disabled={disabled}
      type={'text'}
      data-testid={testId}
      onChange={(e) => handleChange?.(e.target.value ?? '')}
      className={`noto-normal-3 rounded-[5px] bg-light-2 px-[10px] leading-[23px] text-dark-6 placeholder:text-light-5 focus:outline-none ${className} read-only:bg-light-3 disabled:bg-light-3 disabled:text-light-8`}
      defaultValue={text}
      value={value}
    ></input>
  );
};
